import { Moment } from 'moment';
import { DeliveryOrderQuoteDriver } from './delivery-order-quote-driver';
import { DeliveryOrderQuoteManager } from './delivery-order-quote-manager';
import { DeliveryOrderQuoteSchema } from './delivery-order-quote.schema';
import { Entity } from '@core/data/dto/entity';
import { Dto } from '@core/data/dto/dto';
import { DTO_DEFAULT, DtoType } from '@core/data/dto/dto-types';
import { DtoExport, DtoImport } from '@core/utils/dto';

export class DeliveryOrderQuote implements Entity {
    public id: string;
    public serviceProvider: string;
    public provider: string;
    public providerName: string;
    public fee: number;
    public created: Moment;
    public expires: Moment;
    public currency: string;
    public dropoffDuration: number;
    public dropoffEta: Moment;
    public pickupEta: Moment;
    public pickupDuration: number;
    public provisional: boolean;
    public drivers: DeliveryOrderQuoteDriver[];
    public network: DeliveryOrderQuoteManager[];

    @DtoImport(DeliveryOrderQuoteSchema)
    static import(dto: Dto): any {}

    @DtoExport([
        {
            type: DTO_DEFAULT,
            dto: DeliveryOrderQuoteSchema,
        },
    ])
    export(type?: DtoType): any {}
}
